const NATIVE_SPEAKER = 'NS';
const NATIVE_SPEAKER_LABELS = new Set( [
    'langue maternelle',
    'mother tongue',
    'mother language',
] );

function isSet( language ) {
    return Boolean( language?.code );
}

function normalize( value ) {
    return String( value ?? '' )
        .normalize( 'NFD' )
        .replace( /[\u0300-\u036f]/g, '' )
        .replace( /\(s\)/gi, '' )
        .replace( /[^a-z\s]/gi, ' ' )
        .replace( /\s+/g, ' ' )
        .trim()
        .toLowerCase();
}

function isNative( level ) {
    if ( normalize( level?.code ).toUpperCase() === NATIVE_SPEAKER ) {
        return true;
    }

    return Object.values( level?.translations ?? {} )
        .some( label => NATIVE_SPEAKER_LABELS.has( normalize( label ) ) );
}

export function getNativeLanguageCodes( languageSkills = [] ) {
    return languageSkills
        .filter( ( {
                       language,
                       listeningComprehensionLevel,
                       readingComprehensionLevel,
                       continuousOralExpressionLevel,
                       writingExpressionLevel,
                       oralInteractionLevel,
                   } ) =>
                     isSet( language )
                     && isNative( listeningComprehensionLevel )
                     && isNative( readingComprehensionLevel )
                     && isNative( continuousOralExpressionLevel )
                     && isNative( writingExpressionLevel )
                     && isNative( oralInteractionLevel )
        ).map( skill => skill.language.code );
}
